import React from "react";

export default function ColorFrame7({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <circle
          cx="139.207"
          cy="138"
          r="108"
          fill="#8859C2"
          stroke="#D8ACE8"
          strokeWidth="4"
        />
        <circle
          cx="139.617"
          cy="138.41"
          r="84.1418"
          fill="#D8ACE8"
          stroke="#D8ACE8"
          strokeWidth="3.28358"
        />
        <circle
          cx="139.5"
          cy="138.5"
          r="65"
          fill="white"
          stroke="#8859C2"
          strokeWidth="3"
        />
        <path
          d="M260.15 219.269C260.15 207.776 255.5 93 255.5 93C255.5 93 248.953 78.3481 247.311 72.3282C245.669 66.3084 247.962 57.4952 249.536 53.8216L254.404 69.5L258.155 53.8216L264.254 69.5L267.127 53.4476C267.538 54.5422 270.775 60.7735 271.117 66.582C271.527 73.5596 266.281 88.4851 264.754 93C264.754 93 274.4 210.239 275.747 219.269C277.093 228.299 260.15 230.761 260.15 219.269Z"
          fill="#D8ACE8"
        />
        <mask
          id="mask0_2257_162658"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="246"
          y="53"
          width="30"
          height="174"
        >
          <path
            d="M260.15 219.269C260.15 207.776 255.5 93 255.5 93C255.5 93 248.953 78.3481 247.311 72.3282C245.669 66.3084 247.962 57.4952 249.536 53.8216L254.404 69.5L258.155 53.8216L264.254 69.5L267.127 53.4476C267.538 54.5422 270.775 60.7735 271.117 66.582C271.527 73.5596 266.281 88.4851 264.754 93C264.754 93 274.4 210.239 275.747 219.269C277.093 228.299 260.15 230.761 260.15 219.269Z"
            fill="#F8DED8"
          />
        </mask>
        <g mask="url(#mask0_2257_162658)">
          <path
            d="M275.747 219.269C277.093 228.299 260.15 230.761 260.15 219.269C260.15 213.279 258.887 179.231 257.677 148L263 143.5L269.344 148C272.033 179.821 275.038 214.518 275.747 219.269Z"
            fill="#8859C2"
          />
        </g>
        <path
          d="M1.53457 220.009C1.27171 226.943 16.2267 230.287 16.5947 220.58C16.7485 216.524 18.2409 186.813 19.9262 153.597C22.2739 107.329 24.9959 54.26 24.9959 54.26C24.9959 54.26 13.896 51.1632 10.0349 67.4029C9.97113 67.6712 10.7122 68.3544 10.7122 68.3544C10.7122 68.3544 9.73638 68.766 9.68274 69.0447C9.63905 69.2716 10.4593 69.6325 10.4183 69.8663C10.3772 70.1005 9.4748 70.2076 9.43644 70.4488C9.40252 70.6621 10.2323 71.0088 10.2006 71.2276C10.1711 71.4314 9.27991 71.5069 9.25236 71.7156C9.22572 71.9172 10.0616 72.2521 10.0349 72.4589C10.0001 72.7283 9.10263 72.8713 9.06769 73.1492C9.05094 73.2824 9.24448 73.4484 9.44063 73.6157L9.82834 74.1007C9.7952 74.3708 8.89941 74.5138 8.86618 74.791C8.85014 74.9247 9.04524 75.0913 9.24254 75.259L9.6314 75.7425C9.59962 76.0131 8.70521 76.1562 8.67337 76.4328C6.0325 99.3744 3.17527 142.489 3.17527 142.489C3.17527 142.489 9.70672 146.375 9.25236 153.597C8.02571 173.094 1.79743 213.076 1.53457 220.009Z"
          fill="#D8ACE8"
        />
        <mask
          id="mask1_2257_162658"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="54"
          width="24"
          height="173"
        >
          <path
            d="M16.5947 220.58C16.9627 210.873 24.9959 54.26 24.9959 54.26C24.9959 54.26 13.896 51.1632 10.0349 67.4029C9.97113 67.6712 10.7122 68.3544 10.7122 68.3544C10.7122 68.3544 9.73638 68.766 9.68274 69.0447C9.63905 69.2716 10.4593 69.6325 10.4183 69.8663C10.3772 70.1005 9.4748 70.2076 9.43644 70.4488C9.40252 70.6621 10.2323 71.0088 10.2006 71.2276C10.1711 71.4314 9.27991 71.5069 9.25236 71.7156C9.22572 71.9172 10.0616 72.2521 10.0349 72.4589C10.0001 72.7283 9.10263 72.8713 9.06769 73.1492C9.05094 73.2824 9.24448 73.4484 9.44062 73.6157L9.82834 74.1007C9.7952 74.3708 8.89941 74.5138 8.86618 74.791C8.85014 74.9247 9.04523 75.0913 9.24254 75.259L9.6314 75.7425C9.59962 76.0131 8.70521 76.1562 8.67337 76.4328C6.0325 99.3744 3.17527 142.489 3.17527 142.489C3.17527 142.489 9.70672 146.375 9.25236 153.597C8.02571 173.094 1.79743 213.076 1.53457 220.009C1.27171 226.943 16.2267 230.287 16.5947 220.58Z"
            fill="#5F3A59"
          />
        </mask>
        <g mask="url(#mask1_2257_162658)">
          <path
            d="M1.53452 220.009C1.27166 226.942 16.2267 230.287 16.5947 220.58C16.7485 216.524 18.2408 186.813 19.9262 153.597L14.9999 149.5L9.2523 153.597C8.02565 173.094 1.79737 213.076 1.53452 220.009Z"
            fill="#8859C2"
          />
        </g>
        <circle cx="139.617" cy="43.1866" r="3.69403" fill="#D8ACE8" />
        <circle cx="149.468" cy="43.1865" r="2.05224" fill="#D8ACE8" />
        <circle cx="129.766" cy="43.1865" r="2.05224" fill="#D8ACE8" />
        <circle
          cx="234.841"
          cy="135.127"
          r="3.69403"
          transform="rotate(-90 234.841 135.127)"
          fill="#D8ACE8"
        />
        <circle
          cx="234.841"
          cy="125.276"
          r="2.05224"
          transform="rotate(-90 234.841 125.276)"
          fill="#D8ACE8"
        />
        <circle
          cx="234.841"
          cy="144.978"
          r="2.05224"
          transform="rotate(-90 234.841 144.978)"
          fill="#D8ACE8"
        />
        <circle
          cx="44.3934"
          cy="135.127"
          r="3.69403"
          transform="rotate(-90 44.3934 135.127)"
          fill="#D8ACE8"
        />
        <circle
          cx="44.3933"
          cy="125.276"
          r="2.05224"
          transform="rotate(-90 44.3933 125.276)"
          fill="#D8ACE8"
        />
        <circle
          cx="44.3933"
          cy="144.978"
          r="2.05224"
          transform="rotate(-90 44.3933 144.978)"
          fill="#D8ACE8"
        />
        <circle cx="139.617" cy="233.634" r="3.69403" fill="#D8ACE8" />
        <circle cx="149.468" cy="233.634" r="2.05224" fill="#D8ACE8" />
        <circle cx="129.766" cy="233.634" r="2.05224" fill="#D8ACE8" />
        {children}
      </g>
    </svg>
  );
}
